// translations/pages/landing/bg.js

export const landingPageBG = {
  "hero": {
    "title": "pAIoneer Labs GmbH",
    "subtitle": "Локални ИИ решения с фокус върху защитата на данните",
    "vision": "Следващото стъпало на производителността: Organisation as a Service. ИИ служители поемат работа от идеята до проверения резултат.",
    "intro": "Ние изследваме, разработваме и интегрираме технологии в областта на изкуствения интелект, машинното обучение и обработката на данни. От това се раждат наши собствени продукти и специфични за клиента решения, които локално анализират, структурират, анонимизират и защитават данни — а с [Veridion](veridion) и напълно автоматизирани ИИ служители, които заедно с хората поемат цели работни направления в компанията.",
    "detail": "Софтуерът, който инсталираме при клиента, работи в собствената му инфраструктура и не се нуждае от връзка с облака. Документите, данните и езиковите модели остават в самата организация."
  },
  "partners": {
    "title": "Партньори, които ни се доверяват",
    "subtitle": "Компании и изследователски институции, в които нашата ИИ организация работи в реална среда.",
    "items": {
      "bisigma": {
        "name": "BiSigma",
        "tagline": "BioSignal Measurement and Analysis\nРешения за проследяване на погледа и биосигнали за Вашите изследвания",
        "description": [
          "BiSigma е специализирана в системи за измерване и анализ на биосигнали, както и във високопрецизни решения за проследяване на погледа (eye-tracking) за науката, клиничната практика и индустриалните изследвания.",
          "pAIoneer Labs GmbH замени изцяло в BiSigma софтуерната разработка с ИИ, който успешно разработва и непрекъснато надгражда софтуер за измерване и анализ на биосигнали."
        ],
        "cta": "Посетете BiSigma"
      }
    }
  },
  "products": {
    "title": "Продукти",
    "subtitle": "Продаваме софтуер като настолно приложение за работното място, като сървърен софтуер on-premises или в облака на клиента и като абонамент на нашата платформа, какъвто е [асистентът за трейдинг](finance), който нашите ИИ служители сами разработват. Освен това изграждаме ИИ системи според изискванията на клиента и предлагаме консултации и обучения.",
    "partnerLabel": "Партньорски продукт",
    "priceOnRequest": "Цена по запитване",
    "request": "Изпратете запитване",
    "items": {
      "kyveil": {
        "name": "Kyveil Desktop",
        "description": [
          "Kyveil разпознава и анонимизира лични данни във файлове на Word, Excel, OpenDocument, PDF и в текстови файлове, преди те да попаднат в ИИ инструменти, тестове, анализи или при трети страни. Разпознаването съчетава {presidio}, {spacy} и {flair} и работи на немски, английски, френски, италиански и испански.",
          "Настолната версия работи самостоятелно на стандартни компютри с Windows, macOS или Linux, без GPU и без зависимост от мрежа; файловете не напускат работната станция. API версията работи в инфраструктурата на клиента – on-premises или в собствения му облак – и интегрира анонимизацията в съществуващите системи и работни процеси.",
          "Режимът на заместване (Replace) заменя личните данни със заместители за документацията по нормативното съответствие, а режимът с фиктивни данни (Fake) – с правдоподобни заместващи стойности за тестови среди; структурата на документа се запазва. С AnonChat анонимизираният документ стига до ChatGPT, Claude, Gemini или вътрешен езиков модел едва след предварителен преглед."
        ],
        "cta": "Вижте Kyveil"
      },
      "veridion": {
        "name": "Veridion Agentic Company Intelligence",
        "claim": "Един създател, безкрайно много решения.",
        "text": [
          "Фирменият ИИ на pAIoneer Labs GmbH: той управлява цялата компания, като цялостна организация от ИИ служители с бизнес звена от разработката на софтуер през електрониката и квантовите изчисления до продажбите и администрацията, водени от собствен координационен слой.",
          "Тази работна сила самостоятелно довежда докрай проекти, счетоводство, фирмени знания, проучвания, разработка и анализ на данни. Комуникацията ѝ е оптимизирана чрез теория на игрите, а когато ѝ трябва способност, която още не съществува, изгражда за нея собствена ИИ система.",
          "Работи on-premises, в собствения Ви облак или на нашата платформа. Там сама разработва [асистента за трейдинг](finance) и е ИИ в неговия чат."
        ],
        "points": [
          "Интегрира се във всеки процес",
          "Учи се самостоятелно",
          "Сама създава липсващите способности",
          "Планируема във фиксирани цикли"
        ],
        "cta": "Вижте Veridion"
      },
      "robuddy": {
        "name": "RoBuddy",
        "description": [
          "RoBuddy е модулна агентна система за фирми, базирана на ИИ, която автоматизира административни офис задачи.",
          "Пет роли обхващат работното ежедневие: асистентът координира срещи, съставя имейли и изпълнява ежедневни задачи. Коучът подкрепя в емоционални и социални аспекти на професионалното ежедневие, помага при конфликти и подпомага личностното развитие. Помощникът по защита на данните отговаря на специализирани въпроси относно защитата на данните и неприкосновеността на личния живот и може да бъде обучен и за други специализирани области като пожарна безопасност или нормативно съответствие. Обучителят изготвя планове за обучение, програми за въвеждане на нови служители и учебни модули, а консултантът анализира качени документи, подпомага вземането на решения и дава стратегически препоръки.",
          "RoBuddy се хоства и управлява на 100 % по германски стандарти (GDPR, BSI-Grundschutz) и се свързва безпроблемно с Nextcloud или с всеки мрежов диск.",
          "RoBuddy е агентната система за офис работа и може да се свърже с Veridion в един фирмен ИИ, който обхваща цялата компания: RoBuddy поема задачите на работното място, а Veridion свързва системите и данните на компанията."
        ],
        "cta": "Вижте RoBuddy",
        "vendorNote": "RoBuddy е продукт на Dr. Hornecker Software-Entwicklung und IT-Dienstleistungen. Разпространява се от pAIoneer Labs GmbH."
      }
    }
  },
  "platformNote": {
    "title": "SaaS платформа",
    "description": "Това приложение използвате като абонамент директно в браузъра, без инсталация. То работи на нашата собствена платформа, вписването изисква втори фактор, а всички ИИ заявки минават през една централна точка за достъп с фиксирани квоти.",
    "apps": {
      "finance": {
        "name": "ИИ асистент за трейдинг",
        "text": "Свързвате брокерската си сметка, задавате въпроси за позициите си на естествен език и виждате кои новини са повлияли на курсовете. За всеки финансов инструмент прогнозата се изчислява от отделен модел за машинно обучение, който всеки ден се обучава наново, а автоматика може да търгува по сигналите. Асистентът се разработва от нашите ИИ служители; в чата те са и неговият ИИ.",
        "cta": "Вижте асистента за трейдинг"
      }
    }
  },
  "services": {
    "title": "Основни услуги",
    "veridion": {
      "title": "ИИ служители",
      "description": "Цели работни области, поети от ИИ служители, които се интегрират в процесите и инструментите на компанията и самостоятелно довеждат работата докрай. Така работим и ние самите: pAIoneer Labs GmbH върви върху това.",
      "cta": "Вижте Veridion",
      "features": [
        "Organisation as a Service",
        "Бизнес звена от ИИ служители",
        "Комуникация, оптимизирана чрез теория на игрите",
        "On-premises или собствен облак"
      ]
    },
    "custom": {
      "title": "ИИ системи по поръчка на клиента",
      "description": "Разработваме системи за анализ, обработка, структуриране, анонимизиране и защита на данни според изискванията на клиента и ги интегрираме в локални или собствени на клиента ИТ инфраструктури.",
      "features": [
        "Работа без облак",
        "Разработка на продукти",
        "Прототипи",
        "Научноизследователски и развойни проекти"
      ]
    },
    "elektronik": {
      "title": "Електроника и фърмуер",
      "description": "Разработка близо до хардуера като услуга: проектиране на схеми и симулация като дигитален близнак, фърмуер чак до сензора, преценка на компоненти и алтернативи, преди нещо да бъде произведено.",
      "features": [
        "Дигитални близнаци",
        "Вграден фърмуер",
        "Анализ на datasheets",
        "Преценка на компонентите"
      ]
    },
    "quantum": {
          "title": "Суверенни LLM и Квантов ИИ",
          "description": "Нашата цел под Veridion: да разработим компактни езикови модели Made in Germany, които в бъдеще ще се конкурират с големите модели от САЩ и Китай, както и собствени квантови трансформъри.",
          "cta": "Вижте Quantum",
          "features": [
                "LLM Made in Germany",
                "Квантови трансформъри",
                "Собствена Quantum IDE",
                "ИИ развива ИИ"
          ]
    },
    "dataanalysis": {
      "title": "Анализ на данни в разговор",
      "description": "ИИ служител отговаря на въпроси към свързани източници на данни. Той чете каталозите, схемите и колоните на базите данни, представя план за анализ преди достъпа до данните и изяснява двусмислията.",
      "features": [
        "SQL източници на данни",
        "Корелация и регресия",
        "Таблици и диаграми",
        "Експорт в PDF и PowerPoint"
      ]
    },
    "memory": {
      "title": "Фирмена памет",
      "description": "Памет вместо търсене в документи: факти, решения, задачи и процедури, свързани с проектите, хората, системите и документите, към които принадлежат, заедно с времето, в което важат. Тя расте от само себе си от разговори, срещи и работни резултати; по-новото решение замества по-старото по същата тема, нищо не се губи.",
      "features": [
        "Граф на знанията",
        "Факти с време на валидност",
        "Решения, никога изгубени",
        "Достъп според отговорността"
      ]
    },
    "kyveil": {
      "title": "Локална анонимизация без GPU",
      "description": "Kyveil анонимизира лични данни локално – като настолно приложение на стандартни компютри с Windows, macOS или Linux или като REST API в инфраструктурата на клиента, без задължителен облак и без GPU.",
      "cta": "Вижте Kyveil",
      "features": [
        "Анонимизация преди ИИ",
        "Разпознаване на лични данни (PII) с NLP",
        "Windows, macOS, Linux",
        "REST API on-premises"
      ]
    },
    "agenticdev": {
      "title": "Intent-Driven Development",
      "description": "Софтуерната разработка с помощта на ИИ се нуждае от надежден контекст. IDD записва целите, това, което не е цел, сценариите, правилата за агентите и решенията като използваема проектна памет.",
      "cta": "Вижте IDD",
      "features": [
        "Агентна разработка",
        "IDD Vault",
        "Intent/Decisions/Scenarios",
        "Сценариите като тестове"
      ]
    },
    "finance": {
      "title": "Финанси и пазарен анализ",
      "description": "Зад асистента за трейдинг стои собствено бизнес звено от дигитални служители: ИИ data scientists и финансови експерти. Те оценяват новините в реално време, анализират емоциите на финансовите новини и сами извършват изчисления върху пазарните данни в чата: корелации, регресии, диаграми и равносметката на собствените си прогнози, като всяко число произлиза от изпълнена изчислителна стъпка. Под това работят прогноза чрез машинно обучение за всеки финансов инструмент и автоматична търговия в демо сметка и с реални пари.",
      "cta": "Вижте финансовия ИИ",
      "features": [
        "ИИ data scientists и финансови експерти",
        "Новини в реално време, с анализ на емоциите",
        "ML прогноза за всеки финансов инструмент",
        "Автоматична търговия"
      ]
    },
    "consulting": {
      "title": "Консултиране",
      "description": "Консултираме в техническо, организационно и стратегическо отношение при въвеждането, защитата и съобразеното с правилата използване на ИИ.",
      "features": [
        "Управление на ИИ (AI Governance)",
        "Управление на данни",
        "Защита на данните",
        "Информационна сигурност"
      ]
    }
  },
  "contact": {
    "title": "Контакт",
    "addressLabel": "Адрес",
    "phoneLabel": "Телефон",
    "emailLabel": "Имейл",
    "cta": "Напишете съобщение"
  }
};
